<template>
  <div class="lote-container py-3" v-if="lote">
    <div class="card shadow-sm">
      <div class="card-header bg-white d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
        <div class="d-flex align-items-center flex-grow-1 mb-2 mb-md-0">
          <h2 class="lote-title mb-0 text-truncate">
            <font-awesome-icon icon="fas fa-warehouse" class="me-2" />
            {{ lote.nombre }}
            <small class="lote-codigo text-muted ms-2">({{ lote.codigo }})</small>
            <button @click="copiarCodigoLote" class="btn btn-outline-secondary btn-sm ms-2">
              <font-awesome-icon icon="fas fa-copy" class="me-1" />
              Copiar
            </button>
          </h2>
        </div>
        <div class="estado-lote d-flex align-items-center gap-1 mb-2 mb-md-0">
          <font-awesome-icon :icon="lote.lote_bloqueado ? 'lock' : 'unlock'" class="text-primary" />
          <span v-if="lote.lote_bloqueado" class="badge bg-secondary ms-1">
            Bloqueado
          </span>
          <span v-else class="badge bg-success ms-1">
            Editable
          </span>
        </div>
        <div class="lote-actions btn-group" role="group" aria-label="Acciones del lote">
          <button @click="bloquearLote" class="btn btn-outline-secondary btn-sm" :disabled="proyectoCerrado">
            <font-awesome-icon icon="fas fa-lock" class="me-1" />
            <span class="d-none d-md-inline">Bloquear</span>
          </button>
          <button @click="toggleEditModal" class="btn btn-outline-primary btn-sm" :disabled="lote.lote_bloqueado || proyectoCerrado">
            <font-awesome-icon icon="fas fa-edit" class="me-1" />
            <span class="d-none d-md-inline">Editar</span>
          </button>
          <button @click="eliminarLote" class="btn btn-outline-danger btn-sm" :disabled="lote.lote_bloqueado || proyectoCerrado">
            <font-awesome-icon icon="fas fa-trash-alt" class="me-1" />
            <span class="d-none d-md-inline">Eliminar</span>
          </button>
        </div>
      </div>
      <div class="card-body bg-light">
        <div class="row g-2">
          <div class="col-md-4">
            <p class="mb-1"><strong>Fecha de Creación:</strong> {{ lote.fecha_inicio }}</p>
          </div>
          <div class="col-md-4">
            <p class="mb-1"><strong>Descripción:</strong> {{ lote.descripcion }}</p>
          </div>
          <div class="col-md-4 text-center" id="qr-section">
            <QRCode :value="qrData" :size="100" />
            <button id="boton-descargar" class="btn btn-outline-secondary btn-sm mt-1" @click="descargarQR">
              <font-awesome-icon icon="fas fa-download" class="me-1" /> QR
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Listado de plantas del lote -->
    <listarPlantasLote :lote_id="lote.id" :lote_bloqueado="lote.lote_bloqueado" :proyecto_id="proyecto_id" :club_id="club_id" />
  </div>
  <div v-else class="text-center py-4">
    <p>Cargando datos del lote...</p>
  </div>
  
  <!-- Modal de edición -->
  <div v-if="mostrarModal">
    <div class="modal-overlay">
      <div class="modal-content">
        <editar-lote :lote_id="lote.id" :club_id="club_id" :proyecto_id="proyecto_id" @lote-editado="cargarLote" /> 
      </div>
    </div>
  </div>
  

</template>

<script>
import axios from '@/axios';
import QRCode from 'qrcode.vue';
import listarPlantasLote from '../Planta/listar-plantasLote.vue';
import html2canvas from 'html2canvas';
import editarLote from './editar-lote.vue';
export default {
  components: {
    QRCode,
    listarPlantasLote,
    editarLote,
  },
  data() {
    return {
      lote: null, // Datos del lote
      qrData: null, // Datos para el código QR
      qrSize: 150,  // Tamaño del QR (actualmente no utilizado directamente)
      mostrarModal: false, // Control del modal de edición
      loteEditado: {}, // Datos editados del lote
      proyectoCerrado: false, // Estado del proyecto (si está cerrado o no)
      club_id: this.$store.getters.getClubActual.id,
    };
  },
  props: {
    lote_id: {
      type: Number,
      required: true,
    },
    proyecto_id: {
      type: Number,
      required: true,
    }
  },
  methods: {
    async cargarLote() {
      try {
        this.mostrarModal = false;
        const response = await axios.get(`/api/lotes/${this.lote_id}`);
        this.lote = response.data.lote; // Carga los datos del lote
        if (!this.lote) {
          console.error('Lote no encontrado');
          return;
        }
        // Formatear la fecha de creación
        this.lote.fecha_inicio = this.lote.fecha_inicio.substring(0, 10);
        // Incluir el código del lote en los datos del QR
        this.qrData = `Lote: ${this.lote.nombre}\nCódigo: ${this.lote.codigo}\nFecha de Creación: ${this.lote.fecha_inicio}\nProyecto: ${this.proyecto_id}\nClub: ${this.club_id}`;
      } catch (error) {
        console.error('Error al cargar el lote:', error);
      }
    },
    async descargarQR() {
      const qrElement = document.getElementById('qr-section');
      const botonDescarga = document.getElementById('boton-descargar');
      if (qrElement) {
        // Ocultar el botón antes de capturar
        botonDescarga.style.display = 'none';
        const canvas = await html2canvas(qrElement);
        const imgData = canvas.toDataURL('image/png');
        botonDescarga.style.display = 'inline-block';
        const link = document.createElement('a');
        link.href = imgData;
        link.download = `QR_${this.lote.nombre}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    eliminarLote() {
      if (confirm('¿Estás seguro de que deseas eliminar este lote?')) {
        axios.put(`/api/lotes/${this.lote.id}/eliminar`)
          .then(() => {


            this.$emit('lote-eliminado', this.lote);
            
            alert('El lote ha sido eliminado correctamente.');
          })
          .catch(error => {
            console.error('Error al eliminar el lote:', error);
          });

        }
    },
    toggleEditModal() {
      this.loteEditado = { ...this.lote }; // Copia los datos actuales
      this.mostrarModal = !this.mostrarModal;

    },
    guardarCambios() {
      this.lote = { ...this.loteEditado }; // Actualiza el lote con los cambios
      this.toggleEditModal();

    },
    esAdmin() {
      const user = JSON.parse(localStorage.getItem('user'));
      return user?.permisos?.includes('per_admin');
    },
    bloquearLote() {
      if (this.lote.lote_bloqueado) {
        if (!this.esAdmin()) {
          alert('No tienes permiso para desbloquear este lote. Contacta al administrador para que lo desbloquee o descarte el lote.');
          return;
        }

        axios.put(`/api/lotes/${this.lote.id}/desbloquear`)
          .then(() => {

            this.lote.lote_bloqueado = false;
            alert('El lote ha sido desbloqueado correctamente.');
          })
          .catch(error => {
            console.error('Error al desbloquear el lote:', error);
          });
      } else {
        if (confirm('¿Estás seguro de que deseas bloquear este lote? No podrá ser editado ni eliminado. Si lo desea desbloquear deberá contactar al administrador o descartar el lote.')) {
          axios.put(`/api/lotes/${this.lote.id}/bloquear`)
            .then(() => {

              this.lote.lote_bloqueado = true;
              alert('El lote ha sido bloqueado correctamente.');
            })
            .catch(error => {
              console.error('Error al bloquear el lote:', error);
            });
        }
      }
    },
    copiarCodigoLote() {
      navigator.clipboard.writeText(this.lote.codigo)
        .then(() => {
          alert('Código del lote copiado al portapapeles.');
        })
        .catch(err => {
          console.error('Error al copiar el código:', err);
        });
    },
  },
  watch: {
    lote_id: {
      handler: 'cargarLote',
      immediate: true,
    },
  },
  mounted() {
    this.proyectoCerrado = this.$store.getters.getProyectoActual.proyecto_cerrado;
    this.cargarLote();
  },
};
</script>

<style scoped>
/* Contenedor principal */
.lote-container {
  background-color: #ffffff; /* Cambiar a blanco para un look más limpio */
  border-radius: 12px; /* Bordes más redondeados */
  padding: 2rem; /* Más espacio para un diseño más aireado */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); /* Sombra más suave */
}

/* Título del lote */
.lote-title {
  font-size: 1.5rem; /* Reducir tamaño de fuente */
  font-weight: bold;
  color: #2c3e50; /* Color más oscuro para mejor contraste */
  white-space: normal; /* Permitir que el texto se envuelva */
  overflow-wrap: break-word; /* Permitir que las palabras largas se rompan */
}

/* Estilo para el código del lote */
.lote-codigo {
  font-size: 1rem;
  color: #95a5a6; /* Color gris más claro */
}

/* Estado del lote (badges) */
.estado-lote .badge {
  font-size: 0.8rem; /* Reducir tamaño de fuente */
  padding: 0.3rem 0.6rem; /* Reducir espacio interno */
}

/* Botonera */
.lote-actions .btn {
  font-size: 0.8rem; /* Reducir tamaño de fuente */
  padding: 0.4rem 1rem; /* Reducir espacio interno */
  border-radius: 20px; /* Bordes más redondeados */
  transition: background-color 0.3s ease; /* Transición suave para hover */
}

.lote-actions .btn:hover {
  background-color: #3498db; /* Color de fondo al pasar el ratón */
  color: #fff; /* Texto blanco al pasar el ratón */
}

/* Sección del código QR */
#qr-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 0.5rem; /* Reducir espacio superior */
}

#boton-descargar {
  font-size: 0.8rem; /* Reducir tamaño de fuente */
  margin-top: 0.3rem; /* Reducir espacio superior */
  transition: background-color 0.3s ease; /* Transición suave para hover */
}

#boton-descargar:hover {
  background-color: #2ecc71; /* Color de fondo al pasar el ratón */
  color: #fff; /* Texto blanco al pasar el ratón */
}

/* Modal personalizado (si se utiliza en otra parte) */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6); /* Fondo más oscuro */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: #fff;
  padding: 25px; /* Más espacio interno */
  border-radius: 10px; /* Bordes más redondeados */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3); /* Sombra más suave */
  max-width: 600px; /* Ancho máximo más grande */
  width: 90%;
}

.form-group {
  margin-bottom: 1.5rem; /* Más espacio entre grupos de formulario */
}

.btn-secondary {
  background-color: #7f8c8d; /* Color más neutro */
  border-color: #7f8c8d;
}

.btn-primary {
  background-color: #2980b9; /* Azul más vibrante */
  border-color: #2980b9;
}

.card-header {
  padding: 0.5rem 1rem; /* Reducir padding */
  flex-wrap: wrap;
}

.card-body {
  padding: 0.5rem 1rem; /* Reducir padding */
}

.row.g-2 {
  gap: 0.5rem; /* Reducir espacio entre columnas */
}
</style>
